module.exports = __webpack_public_path__ + "static/media/brVideo4.c2827323.mp4";